import { Hash, X } from "lucide-react";

import { Button } from "components/ui/button";

/**
 * How many rows are selected, doubling as the control that clears them —
 * hovering or focusing swaps the hash for an X.
 *
 * One tab stop, and the accessible name states what the click does. The
 * Semantic Reveal this replaces had two buttons, of which the visible one was
 * inert and only the hover-revealed one could clear.
 */
export function SelectedRowsCount({ count, onRemove }) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onRemove}
      aria-label={`Clear ${count} selected`}
    >
      <Hash
        data-icon="inline-start"
        className="tw:group-hover/button:hidden tw:group-focus-visible/button:hidden"
      />
      <X
        data-icon="inline-start"
        className="tw:hidden tw:text-destructive tw:group-hover/button:block tw:group-focus-visible/button:block"
      />
      {count}
    </Button>
  );
}
